module.exports = __webpack_public_path__ + "static/img/__8397.e73b16e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8397.jpg
// module id = mk5k
// module chunks = 0